import { writable } from 'svelte/store';
import { quest } from "./taskTipStore.js";
import { config } from "./firebase-config.js";

console.log('userStore loaded...')
firebase.initializeApp(config);
// firebase.analytics();

function createUser() {
  const emptyUser = {
    userScore: 0,
    quests: [],
    tasks: [], // {'a': 'a'}
    tips: [],
    loading: true
    // currentCourse: -1,
    // currentQuest: -1,
    // currentTask: -1,
    // currentTip: -1
  };
  // let refAllUsers;
  let user = {};
  let ref;
  let currenUserId;
  let currentQuest;
  // let loading = true;
  let justCreatedNewUser = false;

	const { subscribe, set, update } = writable(emptyUser, (set) => {
    console.log('ПОДПИСАЛИСЬ НА USER');
    // console.log('emptyUser', JSON.stringify(emptyUser, null, 2));

    let page;
    let pageHash = window.location.hash.split('#')[1];
  
    switch (pageHash) {
      case "admin":
        page = "admin";      
        break;      
      case "teacher":
        page = "teacher";      
        break;
      default: // User
        page = "student";
        break;
    } 

    set(emptyUser);

    firebase.auth().onAuthStateChanged(function(u) {
      user = emptyUser;
      user.onauth = true;
      if (u) {
        console.log('logged in');
        user.loggedin = true;
        if (page == "student") user.page = page;
        set(user);

        if (page == "student") {
          let q = new URL(window.location.href).searchParams.get("q") || "none";
          window.id_current_user_email = u.email;
          window.id_current_user_name = u.displayName;
          setUserId(u.uid, q, true, true);
        }

        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
          // Send token to your backend via HTTPS
          // console.log('TOKEN:' + idToken);
        }).catch(function(error) {
          // Handle error
        });
        // console.warn('aa');
        // console.warn('sdf' + JSON.stringify(Chatra));
        
        // FIXME
        // if (Chatra != "undefined") Chatra('updateIntegrationData', { name: window.id_current_user_name || "", email: window.id_current_user_email }); 

        // User is signed in.
        // var displayName = u.displayName;
        // var email = u.email;
        // var emailVerified = u.emailVerified;
        // var photoURL = u.photoURL;
        // var uid = u.uid;
        // var phoneNumber = u.phoneNumber;
        // var providerData = u.providerData;
        // userFb = u;
        // userStore.setUserId(uid, q);

        let refAdmin = firebase.database().ref("edulearn/rules/admin/" + firebase.auth().currentUser.uid);
        refAdmin.once("value", function (snap) {      
          if (snap.val()) {
            user.admin = true;
            console.log('page: ' + page);
            if (page == "admin") {
              user.page = page;
              setUserIdFromAdmin(u.uid);
            }
            set(user);
          }
        });

        let refTeacher = firebase.database().ref("edulearn/rules/teachers/" + firebase.auth().currentUser.uid);
        refTeacher.once("value", function (snap) {      
          if (snap.val()) {
            user.teacher = true;
            if (page == "teacher") {
              user.page = page;
              console.log('page: ' + u.uid);
              setUserIdFromAdmin(u.uid);
            }
            set(user);
          }
        });   

      } else {
        console.log('logged out');
        if (user.loggedin) document.location.reload(true); // DIRTY HACK: иначе в Svelte криво отрисовывается анимация

        // user = {tasks:[], tips:[]};
        user.loggedin = false;
        // // user.loggedin = true;
        user.onauth = true;
        user.loading = false;
        // user.page = page;
        set(user);

        // setTimeout(()=>{
        //   user.loggedin = false;
        //   set(user);
        // }, 500);
        // console.log(JSON.stringify(user, null, 2));
        // User is signed out.
      }
    }
    // отключено, чтобы глобально ловились ошибки и сохранялись в БД
    // , function(error) {
    //     console.log(error);
    // }
    );


    // refAllUsers = firebase.database().ref("edulearn/users/info");
    // refAllUsers.on("child_changed", function (snap) {
    //   let questKey = snap.key;
    //   console.log('child_changed: ' + questKey);
    //   // console.log('val', JSON.stringify(snap, null, 2));
    //   // user = snap.val();
    //   if (!Object.values) Object.values = o => Object.keys(o).map(k => o[k]);
    //   if (!user) { // при первом заходе на страницу квест не выбран
    //   }
    // });
    
    return () => {
      user = emptyUser;
      ref && ref.off(); 
      // refAllUsers && refAllUsers.off();
      console.log('ОТПИСАЛИСЬ ОТ USER');
    }
  });

  // function addUser(id) {
  //   console.log('add user', JSON.stringify(id));
  //   emptyUser.id = id;
  //   refAllUsers.child(id).set(emptyUser);
  //   return emptyUser;
  // }  

  function setUserId2(id, q) {
    currenUserId = id;
    ref = firebase.database().ref("edulearn/users/info/" + currenUserId);
    ref.once("value", function (snap) {
      user.name = snap.val().name || "";
      user.email = snap.val().email || "";
      user.id = id;
      user.loading = false;
      user.loggedin = true;
      user.onauth = true;
      user.userScore = user.userScore || 0;      
      let refAdmin = firebase.database().ref("edulearn/rules/admin/" + firebase.auth().currentUser.uid);
      refAdmin.once("value", function (snap) {      
        console.log('snap.val()' + snap.val());
        if (snap.val()) {
          user.admin = true;
        }
        set(user);
        selectQuest(q);
      });      
    });

    let tasksRef = firebase.database().ref("edulearn/users/info/" + currenUserId + "/quests/" + q);
    tasksRef.on("child_added", function (snap) {  
      //user.tasks = [...user.tasks, snap.val()];
    });
    tasksRef.on("child_changed", function (snap) {
      let changedTask = snap.val();
      let foundTask = user.tasks.find(t => {t.id == changedTask.id});
      if (!foundTask) return;
      // const new_obj = { ...foundTask, name: { ...foundTask.name, first: 'blah'} }
      // Object.assign(foundTask, changedTask);
      foundTask = {...foundTask, ...changedTask}
      console.log('task changed: ' + JSON.stringify(foundTask, null, 2))
      set(user);
    });

    let questTasksRef = firebase.database().ref("edulearn/quests/" + q + "/tasks/");
    questTasksRef.on("child_added", function (snap) {  
      let questTask = snap.val();
      let foundTask = user.tasks.find(t => {t.id == questTask.id});
      // if (!foundTask) return;
      foundTask = {...foundTask, ...questTask}
      console.log('questTask added: ' + JSON.stringify(foundTask, null, 2))
      //user.tasks = [...user.tasks, snap.val()];
    });    
  }

  function setUserIdFromAdmin(id) {
    currenUserId = id;
    ref && ref.off();
    ref = firebase.database().ref("edulearn/users/info/" + currenUserId);    
    ref.once("value", function (snap) {
      // сохраняем перед присваиванием из firebase, чтобы не перезатереть
      let isAdmin = user ? user.admin : null;
      let isTeacher = user ? user.teacher : null;
      let onAuthName = user ? user.onAuthName : null;
      let onAuthEmail = user ? user.onAuthEmail : null;
      let page = user ? user.page : null;
      user = snap.val() || {};
      user.loading = false;
      user.loggedin = true;
      user.onauth = true;
      user.userScore = user.userScore || 0;
      user.tasks = [];
      user.tips = [];
      user.admin = isAdmin;
      user.teacher = isTeacher;
      user.page = page;
      user.onAuthName = user.name;
      user.onAuthEmail = user.email;
      user.quests = [];
      console.log(JSON.stringify(user, null, 2))
      set(user);
    });    
  }

  function setUserId(id, q, isOnAuthCalled, isStudent) {
    currenUserId = id;
    // currentQuest = q;
    ref && ref.off();
    ref = firebase.database().ref("edulearn/users/info/" + currenUserId);
    if (justCreatedNewUser) { // НОВЫЙ ЮЗЕР
      //user.quests = []; // у пользователя не было квестов раньше (не нужно, уже при создании в ДБ записали [])
      set(user);
      selectQuest(q); // TODO а что, если новый юзер просто зарегился (без выбора квеста?)
    } else { // ЗАЛОГИНИЛСЯ СТАРЫЙ ЮЗЕР
      console.time('firebase answered in');
      var t0 = performance.now();
      ref.once("value", function (snap) {      
        console.timeEnd('firebase answered in');
        var t1 = performance.now();
        // let logObj = {delay: Math.round(t1 - t0), user: id, quest: q, timestamp: Date.now(), date: (new Date()).toString()};
        // firebase.database().ref("edulearn/users/log/firstpage/all").push(logObj);
        // firebase.database().ref("edulearn/users/log/firstpage/byuser/" + currenUserId).push(logObj);
        firebase.database().ref("edulearn/users/log/firstpage/simple/").child(Date.now() + "_" + id).set(Math.round(t1 - t0));
        
        let questKey = snap.key;

        // сохраняем перед присваиванием из firebase, чтобы не перезатереть
        let isAdmin = user ? user.admin : null;
        let isTeacher = user ? user.teacher : null;
        let onAuthName = user ? user.onAuthName : null;
        let onAuthEmail = user ? user.onAuthEmail : null;
        let page = user ? user.page : null;
        user = snap.val() || {};
        user.loading = false;
        user.loggedin = true;
        user.onauth = true;
        user.userScore = user.userScore || 0;
        user.tasks = [];
        user.tips = [];
        user.admin = isAdmin;
        user.teacher = isTeacher;
        user.student = isStudent;        
        user.page = page;
        if (isOnAuthCalled) {
          user.onAuthName = user.name;
          user.onAuthEmail = user.email;
        } else {
          user.onAuthName = onAuthName;
          user.onAuthEmail = onAuthEmail;
        }
        // console.log('snap user', user);

        if (!user.quests) { // у пользователя не было квестов раньше
          user.quests = [];
        } 

        // let refAdmin = firebase.database().ref("edulearn/rules/admin/" + firebase.auth().currentUser.uid);
        // refAdmin.once("value", function (snap) {      
        //   if (snap.val()) {
        //     user.admin = true;
        //   }
          set(user);
          selectQuest(q);
        // });

        // let refTeacher = firebase.database().ref("edulearn/rules/teachers/" + firebase.auth().currentUser.uid);
        // refTeacher.once("value", function (snap) {      
        //   if (snap.val()) {
        //     user.teacher = true;
        //   }
        //   set(user);
        // });        
      });
    }

    let tasksRef = firebase.database().ref("edulearn/users/info/" + currenUserId + "/quests/" + q + "/tasks/");
    tasksRef.on("child_added", function (snap) {  
      // console.log('task added: ' + new Date());
      // console.warn('task added: ' + snap.key + ' ' + JSON.stringify(snap.val(), null, 2));       
      let changedTask = snap.val();
      let foundTask = user.tasks.find(t => {
        return t.id == changedTask.id
      });
      if (foundTask) {
        console.log('found double');
        logUserTasks();
        return; // если дубль id
      }

      // let newTask = {
      //   id: changedTask.id
      // }

      user.tasks = [...user.tasks, changedTask];
      logUserTasks();
      actualizeUserTasks();
      set(user);
    });
    tasksRef.on("child_changed", function (snap) {
      console.log('task changed: ' + new Date());
      console.log('task changed: ' + snap.key); 
      let changedTask = snap.val();
      let foundTask = user.tasks.find(t => {
        return t.id == changedTask.id
      });
      // console.log('task changed: ' + JSON.stringify(changedTask, null, 2))
      // console.log('task changed foundTask: ' + JSON.stringify(foundTask, null, 2))
      if (!foundTask) return;
      // const new_obj = { ...foundTask, name: { ...foundTask.name, first: 'blah'} }
      // Object.assign(foundTask, changedTask);
      // foundTask = {...foundTask, ...changedTask}
      // foundTask = {...foundTask, ...{done: changedTask.done, check: changedTask.check}}
      // open ??
      if (foundTask.done != changedTask.done 
          || foundTask.check != changedTask.check
          || foundTask.unreadFromTeacher != changedTask.unreadFromTeacher
          || foundTask.unreadFromStudent != changedTask.unreadFromStudent
          || foundTask.checkattemps != changedTask.checkattemps) {
        foundTask.done = changedTask.done;
        foundTask.check = changedTask.check;
        foundTask.unreadFromTeacher = changedTask.unreadFromTeacher;
        foundTask.unreadFromStudent = changedTask.unreadFromStudent;
        foundTask.checkattemps = changedTask.checkattemps;
        console.log('foundTask ' + foundTask.id);
        actualizeUserTasks();  
        // console.log('foundTask = {...foundTask, ...changedTask} ' + JSON.stringify(foundTask, null, 2))
        set(user);
        logUserTasks();
      }
    });
  }

  function getUserId() {
    return currenUserId;
  }

  function getUserName() {
    return user.name;
  }  

  function getUserEmail() {
    return user.email;
  }    

  function selectQuest(id) {
    currentQuest = id;
    quest.setQuestId(id, mergeQuestToUser);
    // quest.setQuestId(id, null);
  }

  function mergeQuestToUser(quest) {
    let id = currentQuest;
    let userQuestInfo = user.quests[id];
    // console.log('userQuestInfo', JSON.stringify(user.quests, null, 2));

    if (!Object.values) Object.values = o => Object.keys(o).map(k => o[k]);
    // if (!userQuestInfo) { // не проходил ранее этот квест, значит добавим стартовую задачу
    //   // if (!quest.getQuestStartTask()) { // если у квеста нет ни одной задачи (нет стартовой задачи) – теперь без разницы
    //   //   return;
    //   // }
    //   let task = {
    //     id: quest.getQuestStartTask(),
    //     done: false,
    //     check: false,
    //     open: true
    //   };
    //   user.quests[id] = {tasks: [task], tips: []}

    //   saveTaskToUser(task);        
    // } else {

    if (userQuestInfo) { // если уже проходил квест
      if (userQuestInfo.tasks) {
        userQuestInfo.tasks = Object.values(userQuestInfo.tasks);
      } else {
        userQuestInfo.tasks = [];
      }
      if (userQuestInfo.tips) {
        userQuestInfo.tips = Object.values(userQuestInfo.tips);
      } else {
        userQuestInfo.tips = [];
      }
    } else {
        user.quests[id] = {tasks: [], tips: []}
    }

    // теперь из параметров метода
    // user.tasks = quest.getTasks().map(t => {
    user.tasks = quest.tasks.map(t => {
      let a = {...user.quests[id].tasks.find(ut => ut.id == t.id), ...t};
      return a;
    });
    // user.tips = quest.getTips().map(t => {
    user.tips = quest.tips.map(t => {
      let a = {...user.quests[id].tips.find(ut => ut.id == t.id), ...t};
      return a;
    });
    actualizeUserTasks();
    set(user); 
  }

  function callAjax(url, callback){
    var xmlhttp;
    // compatible with IE7+, Firefox, Chrome, Opera, Safari
    xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function(){
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200){
            callback(JSON.parse(xmlhttp.response));
        }
    }
    xmlhttp.open("GET", url, true);
    xmlhttp.send();
  }

  function saveTaskToUser(task, fromTeacher) {
    console.log('student: ' + user.student);
    if (!fromTeacher && !user.student) return; // не сохранять для Тичера, только если принудительно нет fromTeacher
    let questId = currentQuest;
    let simpleTask = {
      id: task.id,
      done: task.done || null,
      check: task.check || null,
      open: task.open || null,
      hw: task.hw || null,
      // type: task.type || null,
      unreadFromTeacher: task.unreadFromTeacher || null,
      unreadFromStudent: task.unreadFromStudent || null,
      checkattemps: task.checkattemps || null
    };    
    console.log('saveTaskToUser', JSON.stringify(task.id));
    // console.warn('saveTaskToUser2', JSON.stringify(simpleTask));
    ref && task && task.id && ref.child('quests').child(questId).child('tasks').child(task.id).set(simpleTask); 
  
    logUserTasks();
    // callAjax("https://ipinfo.io/json", function(response) {
    //   console.log(JSON.stringify(response));
    //   // window.geo = {
    //   //   ip: response.ip,
    //   //   city: response.city,   
    //   //   region: response.region,
    //   //   country: response.country
    //   // };
    //   // console.log(window.geo);
    //   // var geo = "default";
    //   // var ip = "default";
    //   // if (window.geo) {
    //   // 	geo = window.geo.country + " " + window.geo.region + " " + window.geo.city;
    //   //   ip = window.geo.ip;
    //   // }
    // });    
  }

  function saveTipToUser(tip) {
    let questId = currentQuest;
    let simpleTip = {
      id: tip.id,
      viewed: tip.viewed || null
    };   
    console.log('saveTipToUser', JSON.stringify(tip.id));
    ref && tip && ref.child('quests').child(questId).child('tips').child(tip.id).set(simpleTip); 
  }
  
  function increaseUserScoreBy(score) {
    user.userScore += score;
    console.log('increaseUserScoreBy', JSON.stringify(score));
    ref && ref.child('userScore').set(user.userScore); 
    let refAllUserList = firebase.database().ref("edulearn/users/list");
    refAllUserList.child(user.id).child('userScore').set(user.userScore);
  }

  function actualizeUserTasks() {
    // console.log('actualizeUserTasks');
    // console.log(Date.now());
    console.warn('actualizeUserTasks');
    
    let questCompleted = true;
    let tasksForOpen = [];
    // у пользователя предзагружены все таски (но не открыты и не доступны могут быть)
    user.tasks.forEach(t => {
      // открываем те, у кого нет предшественников
      let shouldOpen = true;
      // если предшественники есть
      if (t.prev && t.prev.length > 0) {
        switch (t.whenprev) {
          case "and": // закрыть, если хоть одна предыдущая не сделана
            shouldOpen = true;
            if (t.prev.find(tid => user.tasks.find(ut => ut.id == tid 
              && !(ut.done || (ut.check && ut.button == "check"))
              ))) {
              shouldOpen = false;
            }
            break;
          case "or": // открыть, если хоть одна предыдущая сделана
          default:
            shouldOpen = false;
            if (t.prev.find(tid => user.tasks.find(ut => ut.id == tid 
              && (ut.done || (ut.check && ut.button == "check"))
              ))) {
              shouldOpen = true;
            }
            break;
        }
      }

      if ((shouldOpen && !t.open) || (!shouldOpen && t.open)) {
        console.log('act & save: ' + t.id);
        t.open = shouldOpen;
        tasksForOpen = [...tasksForOpen, t];
        // saveTaskToUser(t);
      }

      // если найдена хоть одна задача, которая "не выполнена", значит квест не окончен
      if (!t.done) questCompleted = false;
    })

    tasksForOpen.forEach(t => {
      saveTaskToUser(t);
    });

    if (user.tasks.length == 0 ||  currentQuest == "none" || currentQuest == undefined) questCompleted = false;
    // отметим квест выполненным 
    // todo перенести проверку на бекэнд, чтобы не было потенциальных махинаций
    if (questCompleted) {
      console.log('questCompleted: ' + user.tasks.length);
      let questId = currentQuest;
      let completionDate = Date.now();
      let refAllUserList = firebase.database().ref("edulearn/users/list").child(currenUserId);
      refAllUserList.child("completedquests").child(currentQuest).set(completionDate);
      let questsRef = firebase.database().ref("edulearn/users/info/" + currenUserId + "/quests/" + currentQuest);
      questsRef.child('completed').set(completionDate);
      // ref && task && task.id && ref.child('quests').child(questId).child('tasks').child(task.id).set(simpleTask); 
    }

    logUserTasks();
  }

  function setTaskDone(task) {
    console.log('setTaskDone' + task.id);
    let found = user.tasks.find(ut => ut.id == task.id);
    found.done = true;
    saveTaskToUser(found);
    // task.next && task.next.forEach(i => {
    //   let uTask = user.tasks.find(ut => ut.id == i);
    //   uTask.open = true;
    //   saveTaskToUser(uTask);
    // });
    actualizeUserTasks();
    if (task.score) increaseUserScoreBy(task.score);
    // saveHomeworkFromStudent(task);
    logUserTasks();
  }
  
  function setTaskCheck(task) {
    let found = user.tasks.find(ut => ut.id == task.id);
    found.check = true;
    saveTaskToUser(found);
    if (task.button == "check") {
      // task.next && task.next.forEach(i => {
      //   let uTask = user.tasks.find(ut => ut.id == i);
      //   uTask.open = true;
      //   saveTaskToUser(uTask);      
      // });
      actualizeUserTasks();
    }
    // saveHomeworkFromStudent(task);
  }

  // function saveHomeworkFromStudent(task) {
  //   let link = task.link_from_student;
  //   if (!link) return;
  //   let r = ref && task && task.id && ref.child('quests')
  //     .child(currentQuest).child('tasks').child(task.id).child('hw').push(link); 
  //   let id = r.key;
  //     console.log('id save', JSON.stringify(id, null, 2));
  //   if (task.hw) task.hw[id] = link;
  //   // else task.hw = {id:link}
  //   else {
  //     task.hw = {};
  //     task.hw[id] = link;
  //   }
  // }

  function setTaskReturnToStudent(task) {
    let found = user.tasks.find(ut => ut.id == task.id);
    found.check = null;
    found.done = null;
    saveTaskToUser(task, true);
    // if (task.link_from_student) saveHomeworkFromStudent(task);
  }

  function setTaskPleaseHelp(task) {
    let found = user.tasks.find(ut => ut.id == task.id);
    found.check = true;
    saveTaskToUser(task);
    let help = "\n НЕ ЗНАЮ КАК РЕШИТЬ, ПОМОГИТЕ";
    // task.link_from_student = task.link_from_student ? task.link_from_student + help : help;
    task.link_from_student = help;
    // saveHomeworkFromStudent(task);    
  }

  // function setTaskOnlyReplyIntoChat(task) {
  //   if (task.link_from_student) saveHomeworkFromStudent(task);
  //   // task.link_from_student = "";
  // }

  function resetCurrentQuestHistory() {
    let questId = currentQuest;
    console.log('resetCurrentQuestHistory', questId);
    ref && ref.child('quests').child(questId).set(null); 
  }

  function _increaseUnreadFromTeacher(task) {
    let found = user.tasks.find(ut => ut.id == task.id);
    found.unreadFromTeacher = 1;
    saveTaskToUser(task);
    let refAllUserList = firebase.database().ref("edulearn/users/list").child(currenUserId);
    refAllUserList.child('unreadFromTeacher').set(1);
    let questsRef = firebase.database().ref("edulearn/users/info/" + currenUserId + "/quests/" + currentQuest);
    questsRef.child('unreadFromTeacher').set(1);
  }  

  function _increaseUnreadFromStudent(task) {
    let found = user.tasks.find(ut => ut.id == task.id);
    found.unreadFromStudent = 1;
    saveTaskToUser(task);
    let refAllUserList = firebase.database().ref("edulearn/users/list").child(currenUserId);
    refAllUserList.child('unreadFromStudent').set(1);
    let questsRef = firebase.database().ref("edulearn/users/info/" + currenUserId + "/quests/" + currentQuest);
    questsRef.child('unreadFromStudent').set(1);
  }  

  function _resetUnreadFromTeacher(task) {
    let found = user.tasks.find(ut => ut.id == task.id);
    found.unreadFromTeacher = null;
    saveTaskToUser(task);
    let refAllUserList = firebase.database().ref("edulearn/users/list").child(currenUserId);
    refAllUserList.child('unreadFromTeacher').set(null);
    let questsRef = firebase.database().ref("edulearn/users/info/" + currenUserId + "/quests/" + currentQuest);
    questsRef.child('unreadFromTeacher').set(null);    
  }  

  function _resetUnreadFromStudent(task) {
    let found = user.tasks.find(ut => ut.id == task.id);
    found.unreadFromStudent = null;
    saveTaskToUser(task);
    let refAllUserList = firebase.database().ref("edulearn/users/list").child(currenUserId);
    refAllUserList.child('unreadFromStudent').set(null);
    let questsRef = firebase.database().ref("edulearn/users/info/" + currenUserId + "/quests/" + currentQuest);
    questsRef.child('unreadFromStudent').set(null);     
  }    

  function increaseUnreadFromTeacher(task) {
    task.unreadFromTeacher = (1 + task.unreadFromTeacher) || 1;
    let found = user.tasks.find(ut => ut.id == task.id);
    found.unreadFromTeacher = task.unreadFromTeacher;
    saveTaskToUser(found);
    if (task.unreadFromTeacher > 1) return; // повторные сообщения в задаче не учитывать в агрегации
    firebase.database().ref('edulearn/users/list/' + currenUserId + '/unreadFromTeacher')
      .transaction(u => u + 1);
    firebase.database().ref('edulearn/users/info/' + currenUserId + "/quests/" + currentQuest + '/unreadFromTeacher')
      .transaction(u => u + 1);
  }    

  function increaseUnreadFromStudent(task) {
    task.unreadFromStudent = (1 + task.unreadFromStudent) || 1;
    let found = user.tasks.find(ut => ut.id == task.id);
    found.unreadFromStudent = task.unreadFromStudent;
    // console.log(JSON.stringify(found, null, 2))
    saveTaskToUser(found);
    if (task.unreadFromStudent > 1) return; // повторные сообщения в задаче не учитывать в агрегации
    firebase.database().ref('edulearn/users/list/' + currenUserId + '/unreadFromStudent')
      .transaction(u => u + 1);
    firebase.database().ref('edulearn/users/info/' + currenUserId + "/quests/" + currentQuest + '/unreadFromStudent')
      .transaction(u => u + 1);
  }  

  function resetUnreadFromTeacher(task) {
    if (!task.unreadFromTeacher) return; // если в задаче нет непрочитанных сообщений, то не надо ничего сохранять
    console.log('resetUnreadFromTeacher: ' + task.id);
    task.unreadFromTeacher = null;
    let found = user.tasks.find(ut => ut.id == task.id);
    found.unreadFromTeacher = task.unreadFromTeacher;
    saveTaskToUser(found);
    firebase.database().ref('edulearn/users/list/' + currenUserId + '/unreadFromTeacher')
      .transaction(u => u > 0 ? u - 1 : 0);
    firebase.database().ref('edulearn/users/info/' + currenUserId + "/quests/" + currentQuest + '/unreadFromTeacher')
      .transaction(u => u > 0 ? u - 1 : 0);
  }  

  function resetUnreadFromStudent(task) {
    // console.log('resetUnreadFromStudent ' + user.student);
    if (!task.unreadFromStudent) return; // если в задаче нет непрочитанных сообщений, то не надо ничего сохранять
    task.unreadFromStudent = null;
    let found = user.tasks.find(ut => ut.id == task.id);
    found.unreadFromStudent = task.unreadFromStudent;
    saveTaskToUser(found, true);
    firebase.database().ref('edulearn/users/list/' + currenUserId + '/unreadFromStudent')
      .transaction(u => u > 0 ? u - 1 : 0);
    firebase.database().ref('edulearn/users/info/' + currenUserId + "/quests/" + currentQuest + '/unreadFromStudent')
      .transaction(u => u > 0 ? u - 1 : 0);
  }  

  function createNewUserInDb(name) {
    let u = firebase.auth().currentUser;
    currenUserId = u.uid;
    justCreatedNewUser = true;
    console.log('createNewUserInDb u:', JSON.stringify(u, null, 2));
    
    const newUser = {
      id: u.uid,
      userScore: 0,
      quests: [],
      tasks: [], 
      tips: [],
      name: u.displayName || name || ("Unknown" + Math.round(Math.random()*10000)),
      email: u.email || null,
      loading: false,
      loggedin: true,
      created: Date.now(),
      onauth: true
      // loggedin: null,
      // onauth: null,
    };    
    console.log('newUser', JSON.stringify(newUser, null, 2));
    // user.id = newUser.id;
    user = newUser;
    let refAllUsers = firebase.database().ref("edulearn/users/info");
    refAllUsers.child(newUser.id).set(newUser);
    console.log('saved info');
    let refAllUserList = firebase.database().ref("edulearn/users/list");
    refAllUserList.child(newUser.id).set(newUser);
    console.log('add user', JSON.stringify(newUser, null, 2));
  }

  async function signInAnonymously() {
    try {
      await firebase.auth().signInAnonymously();
      console.log("login");
      createNewUserInDb();
    } catch (e){
        // an error
    } 
  }

  async function createUserWithEmailAndPassword(email, password, name, cb) {
    try {
      console.log(email + ' ' + password)
      await firebase.auth().createUserWithEmailAndPassword(email, password);
      createNewUserInDb(name);
    } catch (e) {
      var errorCode = e.code;
      var errorMessage = e.message;
      console.log('ERROR ' + errorCode + ' ' + errorMessage);
      //signInWithEmailAndPassword(email, password);
      cb(errorCode, errorMessage);
    }  
  }

  async function signInWithEmailAndPassword(email, password, cb) {
    try {
      await firebase.auth().signInWithEmailAndPassword(email, password);
    } catch (e) {
      var errorCode = e.code;
      var errorMessage = e.message;
      console.log('ERROR ' + errorCode + ' ' + errorMessage);
      cb(errorCode, errorMessage);
    }  
  }  

  async function signOut() {
    try {
      await firebase.auth().signOut();
      // signed out
    } catch (e){
        // an error
    }     
  }

  function getOnAuthName() {
    return user.onAuthName;
  }

  function increaseCheckAttemptsCount(task) {
    // console.log('increaseCheckAttemptsCount ' + task.id + ' ' + JSON.stringify(task, null, 2));
    console.log('increaseCheckAttemptsCount ' + task.id);
    task.checkattemps = (1 + task.checkattemps) || 1;    // аналог ++
    firebase.database().ref('edulearn/users/info/' + currenUserId + "/quests/" + currentQuest + '/checkattemps')
      .transaction(u => u + 1);    
    saveTaskToUser(task); // TEMP FIXMI TODO 0706

    firebase.database().ref('edulearn/users/list/' + currenUserId + '/checkattemps')
      .transaction(u => u + 1);
    // firebase.database().ref('edulearn/users/info/' + currenUserId + "/quests/" + currentQuest + '/tasks/' + task.id + '/checkattemps')
    //   .transaction(u => u + 1);    
  }

  function logErrorToDB(m, s) {
    let error = {
      message: m,
      stack: s,
      timestamp: Date.now(),
      time: new Date(),
      userName: user.name || "",
      userEmail: user.email || "",
      userId: currenUserId || ""
    }
    console.warn(error);
    
    firebase.database().ref('edulearn/users/log/jserrors/byuser/' + currenUserId).push(error);
    firebase.database().ref('edulearn/users/log/jserrors/all/').push(error);
  }

  function logUserTasks() {
    // console.log('TASKS: ' + new Date());
    // user.tasks.forEach(t => {
    //   if (t.done || t.open) console.warn('TASKS: ' + t.id + (t.done ? ' DONE' : '') + (t.open ? ' OPEN' : ''));
    // });  
  }

	return {
    subscribe,
    set: set,
    update: update,
    setUserId,
    getUserId,
    getUserName,
    getUserEmail,
    selectQuest,
    saveTaskToUser,
    saveTipToUser,
    increaseUserScoreBy,
    setTaskDone,
    setTaskCheck,
    // saveHomeworkFromStudent,
    setTaskReturnToStudent,
    setTaskPleaseHelp,
    // setTaskOnlyReplyIntoChat,
    resetCurrentQuestHistory,
    increaseUnreadFromTeacher,
    increaseUnreadFromStudent,
    resetUnreadFromTeacher,
    resetUnreadFromStudent,
    signInAnonymously,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    getOnAuthName,
    increaseCheckAttemptsCount,
    logErrorToDB
	};
}

export const user = createUser();